window.chmStorage = (function() {
    var _this, CONFIG, STORAGE, SESSION_STORAGE, EVENTS;

    CONFIG = {
        separator: '::',
        datasetID: 'ScoreTrekBattle'
    };

    STORAGE = {};
    SESSION_STORAGE = {};

    EVENTS = {
        onUpdate: {},
        onUpdateSession: {}
    };

    function init() {
        initStorageObject(false, STORAGE, localStorage);
        initStorageObject(true, SESSION_STORAGE, sessionStorage);
        window.addEventListener('storage', handleUpdates);
    }

    function initStorageObject(useSessionStorage, storageObject, storage) {
        storageObject[CONFIG.datasetID] = {};
        $.each(Object.keys(storage), function(index, key) {
            var keyParts;
            key = String(key);
            keyParts = key.split(CONFIG.separator);
            if ((keyParts.length > 1) && (keyParts.shift() === CONFIG.datasetID)) {
                storageObject[CONFIG.datasetID][keyParts.join(CONFIG.separator)] = load(useSessionStorage, CONFIG.datasetID, keyParts.join(CONFIG.separator));
            }
        });
    }

    function get(useSessionStorage, datasetID, name, update) {
        var storage;
        storage = useSessionStorage ? SESSION_STORAGE : STORAGE;

        if (update) {
            storage[datasetID][name] = load(useSessionStorage, datasetID, name);
        }

        return storage[datasetID][name];
    }

    function set(useSessionStorage, datasetID, name, value) {
        var storage;
        storage = useSessionStorage ? SESSION_STORAGE : STORAGE;

        storage[datasetID][name] = value;
        persist(useSessionStorage, datasetID, name, true);
    }

    function remove(useSessionStorage, datasetID, name) {
        var storage;
        storage = useSessionStorage ? SESSION_STORAGE : STORAGE;

        delete storage[datasetID][name];
        persist(useSessionStorage, datasetID, name, false);
    }

    function load(useSessionStorage, datasetID, name) {
        var storage;
        storage = useSessionStorage ? sessionStorage : localStorage;

        return decode(storage.getItem(key(datasetID ,name)));
    }

    function persist(useSessionStorage, datasetID, name, keep) {
        var storage, storageObject;
        storage = useSessionStorage ? sessionStorage : localStorage;
        storageObject = useSessionStorage ? SESSION_STORAGE : STORAGE;

        if (keep) {
            storage.setItem(key(datasetID, name), encode(storageObject[datasetID][name]));
        } else {
            storage.removeItem(key(datasetID, name));
        }
    }

    function key(datasetID, name) {
        return `${datasetID}${CONFIG.separator}${name}`;
    }

    function encode(dataObj) {
        return btoa(encodeURIComponent(JSON.stringify(dataObj)));
    }

    function decode(dataString) {
        var dataObj;
        try {
            dataObj = JSON.parse(decodeURIComponent(atob(dataString)));
            return (dataObj && (dataObj != '')) ? dataObj : null;
        } catch(e) {
            return null;
        }
    }

    function onUpdate(useSessionStorage, name, updateHandler) {
        var events;
        events = useSessionStorage ? EVENTS.onUpdateSession : EVENTS.onUpdate;

        if (!events.hasOwnProperty(name)) {
            events[name] = [];
        }

        events[name].push(updateHandler);
    }

    function handleUpdates(event) {
        var useSessionStorage, storage, events, keyParts, name;

        useSessionStorage = (event.storageArea === sessionStorage);
        storage = useSessionStorage ? SESSION_STORAGE : STORAGE;
        events = useSessionStorage ? EVENTS.onUpdateSession : EVENTS.onUpdate;

        keyParts = String(event.key || '').split(CONFIG.separator);
        if ((keyParts.length > 1) && (keyParts.shift() === CONFIG.datasetID)) {
            name = keyParts.join(CONFIG.separator);
            if (storage[CONFIG.datasetID].hasOwnProperty(name)) {
                storage[CONFIG.datasetID][name] = decode(event.newValue);
            }
            if (events.hasOwnProperty(name)) {
                events[name].forEach(updateHandler => {
                    ScoreTrekBattle.Event.callFunction(updateHandler, decode(event.newValue), decode(event.oldValue));
                });
            }
        }
    }

    _this = {
        get: function(name, update) {
            return get(false, CONFIG.datasetID, name, !!update);
        },
        getSession: function(name, update) {
            return get(true, CONFIG.datasetID, name, !!update);
        },
        set: function(name, value) {
            return set(false, CONFIG.datasetID, name, value);
        },
        setSession: function(name, value) {
            return set(true, CONFIG.datasetID, name, value);
        },
        remove: function(name) {
            return remove(false, CONFIG.datasetID, name);
        },
        removeSession: function(name) {
            return remove(true, CONFIG.datasetID, name);
        },
        getAll: function() {
            return DataHandler.cloneObject(false, STORAGE[CONFIG.datasetID]);
        },
        getAllSession: function() {
            return DataHandler.cloneObject(true, SESSION_STORAGE[CONFIG.datasetID]);
        },
        onUpdate: function(name, updateHandler) {
            onUpdate(false, name, updateHandler);
        },
        onUpdateSession: function(name, updateHandler) {
            onUpdate(true, name, updateHandler);
        }
    };

    init();

    return _this;
})();
